import FVector from '@data/geometry/FVector';
import { BuildingSource } from '@visualizer/types';
import type { GeoEditManager } from './GeoEditManager';
import { addExtrudedBuildingFromPolygon } from './addExtrudedBuilding';

export function addObstructionFromPolygon(args: {
    editManager: GeoEditManager;
    points: FVector[];
    height: number;
    elevation: number;
    flatTop: boolean;
}) {
    addExtrudedBuildingFromPolygon({
        ...args,
        source: BuildingSource.CUSTOM_OBS,
    });
}
